export const LogoMark = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <path d="M32 10c5 9 5 18 0 25-5-7-5-16 0-25z" fill="currentColor" />
    <path d="M15 22c9 2 15 8 17 16-9-1-15-7-17-16z" fill="currentColor" opacity="0.75" />
    <path d="M49 22c-9 2-15 8-17 16 9-1 15-7 17-16z" fill="currentColor" opacity="0.75" />
    <path d="M12 42c11 8 29 8 40 0-4 8-11 13-20 13s-16-5-20-13z" fill="currentColor" />
  </svg>
);

export const Logo = ({ className = "", light = false }) => (
  <span className={`inline-flex items-center gap-3 ${light ? "text-[#F9F6F0]" : "text-foreground"} ${className}`}>
    <LogoMark className={`h-7 w-7 ${light ? "text-[#E9B277]" : "text-accent"}`} />
    <span className="font-serif text-xl font-medium tracking-[0.35em]">AYURENEW</span>
  </span>
);
